import { Component, Input, OnInit } from '@angular/core';

import { IModalComponent, IModalData } from '@app/interfaces';
import { PartnerAccountToOnboard } from '../../../interfaces/partner-links.interface';
import {
	IProgressBar,
	PartnerOnboardingService,
} from '../../../services/partner-onboarding-service/partner-onboarding.service';

@Component({
	selector: 'app-partner-finish-onboarding-modal',
	templateUrl: './partner-finish-onboarding-modal.component.html',
	styleUrls: ['./partner-finish-onboarding-modal.component.scss'],
})
export class PartnerFinishOnboardingModalComponent implements IModalComponent<{}>, OnInit {
	@Input() data: IModalData<{}>;
	onboardingInProgress: boolean;
	onboardingSuccess: boolean;
	progressBar: IProgressBar;
	errorMessage = '';
	onboardedAccounts: PartnerAccountToOnboard[];

	constructor(private onboardingService: PartnerOnboardingService) {
		this.onboardingService.onboardingInProgress$.subscribe((value) => (this.onboardingInProgress = value));
		this.onboardingService.onboardingSuccess$.subscribe((value) => (this.onboardingSuccess = value));
		this.progressBar = this.onboardingService.progressBar;
		this.onboardingService.onboardedAccounts.subscribe((value) => (this.onboardedAccounts = value));
	}

	ngOnInit() {}

	minifyModal() {
		this.onboardingService.showMinifiedProgress$.next(true);
		this.closeEvent();
	}

	closeEvent(e?: {}): void {}
}
